/**
 * Состав пака «plain-list» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 28 воронок: группы.json, группы 6 (PACK в matrix.py)
  palettes: [
    // 5 из 28 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.18 },
    // 4 из 28 воронок: palette → ближайшая тема по цветам
    { themeId: 'paper-white', weight: 0.14 },
    // 3 из 28 воронок: palette → ближайшая тема по цветам
    { themeId: 'study-blue', weight: 0.11 },
  ],
  fonts: [
    // 19 из 28 воронок: fontId
    { fontId: 'inter', weight: 0.68 },
    // 2 из 28 воронок: fontId
    { fontId: 'poppins', weight: 0.07 },
    // 2 из 28 воронок: fontId
    { fontId: 'roboto', weight: 0.07 },
  ],
  screenKinds: [
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.419; сюда свёрнуты Q10, Q13, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.5 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.115
    { kind: 'N1', share: 0.14 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.088; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.1 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.080; сюда свёрнуты Q16 (замена из arsenal.mjs)
    { kind: 'N4', share: 0.09 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.060
    { kind: 'N6', share: 0.07 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.054
    { kind: 'N5', share: 0.06 },
    // средняя доля экранов по 28 воронкам (признаки.json kinds) 0.031; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.04 },
  ],
  blocks: [
    // в 28 из 28 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 254 из 309, optionIndicator 186 из 309
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 16 из 28 воронок (признаки.json blocks), подъём 1.27
    { type: 'multiple_choice', weight: 0.57, settings: {} },
    // в 12 из 28 воронок (признаки.json blocks), подъём 1.48
    { type: 'text_field', weight: 0.43, settings: {} },
  ],
  niches: [
    // 4 из 28 воронок (признаки.json theme)
    { niche: 'education', weight: 0.14 },
    // 3 из 28 воронок (признаки.json theme)
    { niche: 'language_learning', weight: 0.11 },
    // 3 из 28 воронок (признаки.json theme)
    { niche: 'health', weight: 0.11 },
    // 3 из 28 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.11 },
  ],
};
